import React from 'react';
import styles from './ContactUs.module.css';
import bannerImage from '../../shreeombanner.jpeg';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import Usrnav from '../../usercomponents/Usrnav/Usrnav';

const ContactUs = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your form submission logic here
    alert('Thank you for your message! We will contact you soon.');
  };

  return (
        
    <div className={styles.contactMain}>
       <div className="nav-wrapper">
              <Usrnav />
            </div>
    <div className={styles.contactContainer}>
  
      <div className={styles.heroSection} style={{
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bannerImage})`
                }}>
        <h1>Contact <span>ShreeOhm</span></h1>
        
        <p>We'd love to hear from you!</p>
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.contactInfo}>
          <h2>Get in Touch</h2>
          
          <div className={styles.infoCard}>
            <FaMapMarkerAlt className={styles.icon} />
            <div>
              <h3>Our Location</h3>
              <p>Birendranagar-10, Surkhet</p>
              <p>Karnali Province, Nepal</p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <FaPhone className={styles.icon} />
            <div>
              <h3>Phone</h3>
              <p>+977-9858060350</p>
              <p>+977-01XXXXXXX</p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <FaEnvelope className={styles.icon} />
            <div>
              <h3>Email</h3>
              <p>shreeohm083@gmail.com</p>
              <p>shreeohm083@gmail.com</p>
            </div>
          </div>

          <div className={styles.infoCard}>
            <FaClock className={styles.icon} />
            <div>
              <h3>Opening Hours</h3>
              <p>Sunday-Friday: 7:00 AM - 7:00 PM</p>
              <p>Saturday: 8:00 AM - 5:00 PM</p>
            </div>
          </div>

          <div className={styles.socialLinks}>
            <a href="https://facebook.com/shreeohm" target="_blank" rel="noopener noreferrer">
              <FaFacebook className={styles.socialIcon} />
            </a>
            <a href="https://instagram.com/shreeohm" target="_blank" rel="noopener noreferrer">
              <FaInstagram className={styles.socialIcon} />
            </a>
            <a href="https://wa.me/+977 986-9251675" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp className={styles.socialIcon} />
            </a>
          </div>
        </div>

        <div className={styles.contactForm}>
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Your Name</label>
              <input type="text" id="name" required />
            </div>
            
            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" required />
            </div>
            
            <div className={styles.formGroup}>
              <label htmlFor="phone">Phone Number</label>
              <input type="tel" id="phone" />
            </div>
            
            <div className={styles.formGroup}>
              <label htmlFor="subject">Subject</label>
              <select id="subject" required>
                <option value="">Select a subject</option>
                <option value="order">Order Inquiry</option>
                <option value="product">Product Question</option>
                <option value="feedback">Feedback</option>
                <option value="other">Other</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label htmlFor="message">Your Message</label>
              <textarea id="message" rows="5" required></textarea>
            </div>
            
            <button type="submit" className={styles.submitButton}>
              Send Message
            </button>
          </form>
        </div>
      </div>

      <div className={styles.mapContainer}>
        <iframe 
          title="ShreeOhm Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1412.0050840531516!2d81.6072668!3d28.5950486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a2850018d1b611%3A0x15cc81f7fdfa88c1!2sShree%20Om%20Organic%20Devine%20Enterprises!5e1!3m2!1sen!2snp!4v1717400000000!5m2!1sen!2snp"


          width="100%"
          height="450"
          style={{border:0}}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
    </div>
  );
};

export default ContactUs;